import {
  Base64EncodingType,
  DpInferenceConfig,
  DpModelType,
  DpModelMetadata,
  ModeType,
  OutputFormatType,
} from "../types/dpInferenceConfig";

export const DP_MODEL_METADATA_MAP: Record<DpModelType, DpModelMetadata> = {
  "document-parse-nightly": {
    apiName: "document-parse-nightly",
    displayName: "Document Parse Nightly",
    requiredRoles: undefined,
    endpointType: "layout-analysis",
  },
  "document-parse-260128": {
    apiName: "document-parse-260128",
    displayName: "Document Parse 260128",
    requiredRoles: undefined,
    endpointType: "layout-analysis",
  },
  "document-parse-260630": {
    apiName: "document-parse-260630",
    displayName: "Document Parse 260630",
    requiredRoles: undefined,
    endpointType: "layout-analysis",
  },
  "document-parse-260930": {
    apiName: "document-parse-260930",
    displayName: "Document Parse 260930",
    requiredRoles: undefined,
    endpointType: "layout-analysis",
  },
};

export const OUTPUT_FORMATS_OPTIONS: {
  key: OutputFormatType;
  label: string;
}[] = [
  { key: "html", label: "HTML" },
  { key: "text", label: "Text" },
  { key: "markdown", label: "Markdown" },
];

export const BASE64_ENCODING_OPTIONS: {
  key: Base64EncodingType;
  label: string;
}[] = [
  { key: "figure", label: "Figure" },
  { key: "table", label: "Table" },
  { key: "chart", label: "Chart" },
  { key: "heading1", label: "Heading1" },
  { key: "header", label: "Header" },
  { key: "footer", label: "Footer" },
  { key: "caption", label: "Caption" },
  { key: "paragraph", label: "Paragraph" },
  { key: "equation", label: "Equation" },
  { key: "list", label: "List" },
  { key: "index", label: "Index" },
  { key: "footnote", label: "Footnote" },
  { key: "code", label: "Code" },
];

export const DEFAULT_DP_MODE: ModeType = "standard";

export const DEFAULT_DP_INFERENCE_CONFIG: DpInferenceConfig = {
  model: "document-parse-260930",
  mode: DEFAULT_DP_MODE,
  ocr: "auto",
  mergeMultipageTables: false,
  chartRecognition: true,
  coordinates: true,
  outputFormats: ["html"],
  base64Encoding: ["figure"],
};
